<template>
  <div>
    <vheader :is_reg="false" />
    <div class="agree">
      <div class="agree__title">{{ $tr('onlineInterview.room.login') }}</div>
      <vinput
        :value="name"
        :placeholder="$tr('onlineInterview.room.enterName')"
        :custom_online="true"
        @input="set_name"
      />
      <div class="agree__check">
        <vchecklabel
          :value="agree"
          :label="agree_text"
          :custom_online="true"
          @input="set_agree"
        />
      </div>

      <vbutton
        label="onlineInterview.room.nextStep"
        :loading="loading"
        :disabled="!agree"
        @click="next_step"
      />

      <div
        class="agree__login"
        v-html="
          $tr('onlineInterview.room.loginVCV', {
            reg_link: this.reg_link
          })
        "
      ></div>
    </div>
  </div>
</template>

<script>
import vheader from '@/routes_new/outer/components/vheader.vue';

export default {
  name: 'Agree',

  components: {
    vheader
  },

  props: {
    agree: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      name: '',
      agree1: false
    };
  },

  computed: {
    locale() {
      return this.$store.getters['locale/current'];
    },

    privacy_link() {
      if (this.locale === 'ru') {
        return 'https://vcv.ru/pages/privacy-policy';
      } else if (this.locale === 'en') {
        return 'https://vcv.ai/pages/privacy-policy';
      } else if (this.locale === 'ja') {
        return 'https://vcv.co.jp/privacy_policy/';
      } else {
        return 'https://vcv.ai/pages/privacy-policy';
      }
    },

    terms_link() {
      return 'https://vcv.ai/pages/terms-of-service';
    },

    reg_link() {
      return `${window.location.origin}/login?redirect=${encodeURIComponent(window.location.pathname)}`;
    },

    cookies_link() {
      switch (this.lang) {
        case 'en':
          return 'https://vcv.ai/pages/cookies-terms';
        case 'ru':
          return 'https://vcv.ru/pages/cookies-terms-ru';
        case 'ja':
          return 'https://vcv.ai/pages/cookies-terms';
        default:
          return 'https://vcv.ai/pages/cookies-terms';
      }
    },

    agree_text() {
      return this.$tr('vacancy.openRegistration.personalAgree', {
        user_agreement_link: this.user_agreement_link,
        privacy_link: this.privacy_link,
        terms_link: this.terms_link,
        cookies_link: this.cookies_link
      });
    }
  },

  methods: {
    set_name(v) {
      this.name = v;
    },

    next_step() {
      this.$emit('next_step', this.name);
    },

    set_agree(v) {
      this.$emit('set_value', v);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.agree {
  width: 500px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 37px 25px 32px 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;

  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    letter-spacing: 0.005em;
    color: #233346;
    margin-bottom: 27px;
  }

  &__check {
    margin: 35px 0 45px;
  }

  &__login {
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: #233346;
    margin-top: 34px;

    ::v-deep.reg_link {
      color: $green;
    }
  }
}
</style>
